import { ContextMenuService } from 'sharebase/services/contextMenuService';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { ActionService } from 'phoenix/services/actionService';
import { NotificationAction } from './notifications.actions';
import { ActionRepository } from 'sharebase/services/actionRepository';
import { ClientNotification } from 'sharebase/domain';

require('./notifications.styles');
const template = require('./notifications.template');

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaNotifications
 * 
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaNotifications` displays users notifcations
 *
 * @usage
 *
 * <sba-notifications item-index="0" /> 
 * 
 * @element input
 * @param {integer=} itemIndex The index of the folder item to be displayed at the top
 */
export function NotificationsDirective() {
	return {
		restrict: 'E',
		controller: NotificationsController,
		controllerAs: 'vm',
		template,
		bindToController: {
			itemIndex: '@'
		},
		scope: true,
		link: function (scope, element, attrs) {
			scope.$watch('vm.itemIndex', function(newVal, oldVal){
				if(!newVal){return;}
				element.attr('item-index', scope.vm.itemIndex);
			});

			scope.$on('$destroy', function(){
				scope.vm.subscriptions.forEach(function(subscription){
					subscription();
				});
				
			});
		}
	};
}

function NotificationsController(
	$timeout:ng.ITimeoutService, 
	$filter:ng.IFilterService, 
	$mdDialog, 
	sbContextMenuService:ContextMenuService, 
	pxActionService:ActionService, 
	sbToastService, 
	sbActionRepository:ActionRepository,
	sbaNotificationDataStore, 
	sbaToolbarService:ToolbarService, 
	gettextCatalog:ng.gettext.gettextCatalog
) {
	var vm = this;
	vm.uiLoaded = false;
	vm.clearNotification = clearNotification;

	vm.sbaToolbarService = sbaToolbarService;
	sbaToolbarService.title = gettextCatalog.getString('Notifications');
	vm.notificationDS = sbaNotificationDataStore;

	function getNotifications() {
		return sbaNotificationDataStore
			.load(100)
			.then((notifications:ClientNotification[]) => {
				sbaToolbarService.actionTarget = notifications;
			})
			.finally(() => vm.uiLoaded = true);
	}

	function clearAll(target, $event){
		var confirm = $mdDialog.confirm()
			.title(gettextCatalog.getString('Would you like to clear all notifications?'))
			.textContent(gettextCatalog.getString('All of the your current notifications will be cleared.'))
			.ariaLabel(gettextCatalog.getString('Clear all notifications'))
			.targetEvent($event)
			.ok(gettextCatalog.getString('Clear'))
			.cancel(gettextCatalog.getString('Cancel'));

			$mdDialog.show(confirm).then(function() {
				//user selected clear
				sbaNotificationDataStore.clearAll()
					.catch(function(error){
						sbToastService.showSimple(gettextCatalog.getString('Unable to clear all notifications.'));
					});
			}, angular.noop);
	}

	function clearNotification(item){
		sbaNotificationDataStore.clearNotification(item, false)
			.then(function(){							
				var index = sbaNotificationDataStore.notifications.indexOf(item);
				item.clearing = true;
				$timeout(function(){
					sbaNotificationDataStore.notifications.splice(index, 1);
				}, 400);
			})
			.catch(function(error){
				sbToastService.showSimple(gettextCatalog.getString('Unable to clear notifications.'));
			});
	}

	vm.subscriptions = [];
	let clearAllItem = sbActionRepository.createFromActionName(NotificationAction.ClearAll, false);
	clearAllItem.addTrigger(clearAll);
	vm.subscriptions.push(sbaToolbarService.addItem(clearAllItem));
	getNotifications();
}

NotificationsController.$inject = [
	'$timeout',
	'$filter',
	'$mdDialog',
	'sbContextMenuService',
	'pxActionService',
	'sbToastService',
	'sbActionRepository',
	'sbaNotificationDataStore',
	'sbaToolbarService',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/notifications/notifications.ts